import React, { FC, ReactNode } from 'react';
import { FixedSizeList as VList } from 'react-window';
import classnames from 'classnames';
import { IListData, VirtualProps } from '../../interface';

interface IVirtualProps extends VirtualProps {
  data: IListData[];
  renderItem: (item: IListData, index?: number) => ReactNode;
}

const Virtual: FC<IVirtualProps> = (props) => {
  const { className, data, renderItem, ...rest } = props;
  return (
    <VList
      className={classnames('fs-virtual-list', className)}
      height={200}
      width="100%"
      {...rest}
      itemCount={data.length}
    >
      {({ index, style }) => {
        return (
          <div style={style} className="fs-virtual-item">
            {renderItem(data[index], index)}
          </div>
        );
      }}
    </VList>
  );
};

export default Virtual;
